import React, { createContext, useContext, ReactNode } from "react";

interface MeuPerfilContextData {}

const MeuPerfilContext = createContext<MeuPerfilContextData>(
  {} as MeuPerfilContextData
);

export const MeuPerfilProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  return (
    <MeuPerfilContext.Provider value={{}}>{children}</MeuPerfilContext.Provider>
  );
};

export const useMeuPerfil = () => {
  const context = useContext(MeuPerfilContext);
  if (!context) {
    throw new Error("useMeuPerfil deve ser usado dentro de MeuPerfilProvider");
  }
  return context;
};
